






























































































































import { Component, Vue } from "vue-property-decorator";
import Monitoring from "@/services/bridgingVclaim/Monitoring";
import SEP from "@/services/bridgingVclaim/SEP";
import moment from "moment";
import { appModule } from "@/store/modules/app";

@Component
export default class DataSEPTabView extends Vue {
  //   {
  //   "tujuanrujuk": "BED",
  //   "nmtujuanrujuk": "BEDAH",
  //   "nmpoliasal": "PENYAKIT DALAM",
  //   "tglrujukinternal": "2022-01-28",
  //   "nosep": "1205R0010122V000078",
  //   "nosepref": null,
  //   "ppkpelsep": "1205R001",
  //   "nokapst": "0002081643232",
  //   "tglsep": "2022-01-17",
  //   "nosurat": "1205R0010122N000004",
  //   "flaginternal": "0",
  //   "kdpoliasal": "0002081643232",
  //   "kdpolituj": "BED",
  //   "kdpenunjang": "0",
  //   "nmpenunjang": "",
  //   "diagppk": "K10",
  //   "kddokter": "27667",
  //   "nmdokter": "dr. Surya Habsara, Sp.B.",
  //   "flagprosedur": "0",
  //   "opsikonsul": "5",
  //   "flagsep": "False",
  //   "fuser": "user ws",
  //   "fdate": "2022-01-28",
  //   "nmdiag": "Other diseases of jaws"
  // }

  jenisPelayanan = "2";
  tgl = moment().format("YYYY-MM-DD");
  listSep = [];
  sepSelected = "";
  listSepInternal = [];
  user = "user ws";

  expanded = [];
  jnsPelayananOptions = [
    { kode: "1", name: "Rawat Inap" },
    { kode: "2", name: "Rawat Jalan" },
  ];
  tglShow = false;
  loadingListSep = false;
  loadingListSepInternal = false;
  sepHeaders = [
    {
      text: "No.SEP",
      align: "start",
      sortable: false,
      value: "noSep",
    },
    {
      text: "Tgl.SEP",
      align: "start",
      sortable: false,
      value: "tglSep",
    },
    {
      text: "Tgl pulang SEP",
      align: "start",
      sortable: false,
      value: "tglPlgSep",
    },
    {
      text: "Jenis Pelayanan",
      align: "start",
      sortable: false,
      value: "jnsPelayanan",
    },
    {
      text: "Kelas Rawat",
      align: "start",
      sortable: false,
      value: "kelasRawat",
    },
    {
      text: "No. Kartu",
      align: "start",
      sortable: false,
      value: "noKartu",
    },
    {
      text: "Nama Peserta",
      align: "start",
      sortable: false,
      value: "nama",
    },
    {
      text: "Poli",
      align: "start",
      sortable: false,
      value: "poli",
    },
    {
      text: "Diagnosis",
      align: "start",
      sortable: false,
      value: "diagnosa",
    },
    {
      text: "No.Rujukan",
      align: "start",
      sortable: false,
      value: "noRujukan",
    },
    { text: "", value: "data-table-expand" },
  ];
  tblSepInternalHeaders = [
    { text: "No." },
    { text: "Poli Asal" },
    { text: "No. SEP" },
    { text: "Tgl. SEP" },
    { text: "Diagnosis" },
    { text: "Poli Tujuan" },
    { text: "No. Surat" },
    { text: "Dokter Tujuan" },
    { text: "Penunjang" },
    { text: "Aksi" },
  ];

  getData() {
    this.loadingListSep = true;

    Monitoring.getDataKunjungan(this.tgl, this.jenisPelayanan)
      .then((resp) => {
        this.listSep = resp;
      })
      .finally(() => {
        this.loadingListSep = false;
      });
  }

  getDataSepInternal(item) {
    this.loadingListSepInternal = true;

    SEP.getSepInternal(item.item.noSep)
      .then((resp) => {
        this.listSepInternal = resp.data ?? [];
      })
      .finally(() => {
        this.loadingListSepInternal = false;
      });
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }

  deleteSepInternal(term) {
    SEP.deleteSepInternal(term.noSep, { ...term, user: this.user }).then(
      (resp) => {
        if (resp.status == 1) {
          appModule.NoticeDelayAlert("Berhasil menghapus SEP Internal");
          this.getDataSepInternal({ item: { noSep: term.noSep } });
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      }
    );
  }
}
